var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.188 6.96233C0.967832 5.46333 1.85596 4.07203 3.2111 3.39446L7.2111 1.39446C8.33721 0.831404 9.6627 0.831404 10.7888 1.39446L14.7888 3.39446C16.1439 4.07203 17.0321 5.46332 16.8119 6.96233C16.1654 11.3644 13.8623 16.3285 10.0693 18.0996C9.39248 18.4156 8.60743 18.4156 7.93062 18.0996C4.13766 16.3285 1.83456 11.3644 1.188 6.96233Z",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.32cd35a3e59ecaa0905bff1d2b2f0362.svg";
export { ForwardRef as ReactComponent };